import {
    IS_LOADING, SUBADMIN_LIST_SUCCESS, SUBADMIN_LIST_ERROR, CREATE_SUBADMIN_SUCCESS, CREATE_SUBADMIN_ERROR, SUBADMIN_STATUS_SUCCESS, SUBADMIN_STATUS_ERROR,
    SUBADMIN_DELETE_SUCCESS, SUBADMIN_DELETE_ERROR, SUBADMIN_VIEW_SUCCESS, SUBADMIN_VIEW_ERROR, SUBADMIN_UPDATE_SUCCESS, SUBADMIN_UPDATE_ERROR
} from "../actions/Type";

const initialState = {
    subadmin_list: {},
    create_subadmin: {},
    subadmin_status: {},
    subadmin_delete: {},
    subadmin_view: {},
    subadmin_update: {}
};

export const SubadminReducrs = (
    state = initialState,
    { type, payload } = {},
) => {
    switch (type) {
        case IS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case SUBADMIN_LIST_SUCCESS:
            return {
                ...state,
                subadmin_list: payload,
                loading: false,
            };
        case SUBADMIN_LIST_ERROR:
            return {
                ...state,
                subadmin_list: payload,
                loading: false,
            };
        case CREATE_SUBADMIN_SUCCESS:
            return {
                ...state,
                create_subadmin: payload,
                loading: false,
            };
        case CREATE_SUBADMIN_ERROR:
            return {
                ...state,
                create_subadmin: payload,
                loading: false,
            };

        case SUBADMIN_STATUS_SUCCESS:
            return {
                ...state,
                subadmin_status: payload,
                loading: false,
            };
        case SUBADMIN_STATUS_ERROR:
            return {
                ...state,
                subadmin_status: payload,
                loading: false,
            };

        case SUBADMIN_DELETE_SUCCESS:
            return {
                ...state,
                subadmin_delete: payload,
                loading: false,
            };
        case SUBADMIN_DELETE_ERROR:
            return {
                ...state,
                subadmin_delete: payload,
                loading: false,
            };

        case SUBADMIN_VIEW_SUCCESS:
            return {
                ...state,
                subadmin_view: payload,
                loading: false,
            };
        case SUBADMIN_VIEW_ERROR:
            return {
                ...state,
                subadmin_view: payload,
                loading: false,
            };

        case SUBADMIN_UPDATE_SUCCESS:
            return {
                ...state,
                subadmin_update: payload,
                loading: false,
            };
        case SUBADMIN_UPDATE_ERROR:
            return {
                ...state,
                subadmin_update: payload,
                loading: false,
            };
        default:
            return state;
    }
};